import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import MovementForm from '../../components/MovementForm'
import MovementsTable from '../../components/MovementsTable'
import { actions } from '../../StockMovementsState'
import * as S from './MovementsPage.styles'

const MovementsPage = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.reset())
  }, [dispatch])

  return (
    <S.Wrapper>
      <h1>Histórico de Movimentações</h1>
      <MovementForm />
      <MovementsTable />
    </S.Wrapper>
  )
}

export default MovementsPage
